import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inspectionlist',
  templateUrl: './inspectionlist.component.html',
  styleUrls: ['./inspectionlist.component.css']
})
export class InspectionlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
